import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { ContentBlockerField, EContentBlockerVisualType, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
const IRRELEVANT_VISUAL_TYPES = [
    undefined,
    null,
    EContentBlockerVisualType.Default
];
Object.freeze(IRRELEVANT_VISUAL_TYPES);
function FormFieldContentBlockerTemplateVisualType() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Textbox"),
                value: EContentBlockerVisualType.Default
            },
            {
                label: t("Wrapped"),
                value: EContentBlockerVisualType.Wrapped
            },
            {
                label: t("Hero"),
                value: EContentBlockerVisualType.Hero
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.VisualType,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prev, next)=>prev.isVisual !== next.isVisual || prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>getFieldValue("isVisual") === true && /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(ContentBlockerField.VisualType, t),
                    shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
                    required: true,
                    children: ({ getFieldValue })=>{
                        const extended = getFieldValue(TemplateMetaDataField.Extends);
                        const extendedVisualType = extended?.[ContentBlockerField.VisualType];
                        return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ContentBlockerField.VisualType,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    value: extendedVisualType,
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid",
                                    disabled: true
                                })
                            }),
                            children: /*#__PURE__*/ _jsx(Form.Item, {
                                name: ContentBlockerField.VisualType,
                                noStyle: true,
                                rules: [
                                    {
                                        required: true,
                                        message: t("Please choose visual type.")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Radio.Group, {
                                    options: options,
                                    optionType: "button",
                                    buttonStyle: "solid"
                                })
                            })
                        });
                    }
                })
        })
    });
}
export { FormFieldContentBlockerTemplateVisualType, IRRELEVANT_VISUAL_TYPES };
